import React, { useEffect, useRef, useState } from "react";
import logo1 from "../AboutUsPage/images/logo1.png";
import logo2 from "../AboutUsPage/images/logo2.png";
import logo3 from "../AboutUsPage/images/logo3.png";
import logo4 from "../AboutUsPage/images/logo4.png";
import logo5 from "../AboutUsPage/images/logo5.png";
import logo6 from "../AboutUsPage/images/logo6.png";
import logo7 from "../AboutUsPage/images/logo7.png";
import logo8 from "../AboutUsPage/images/logo8.png";
import logo9 from "../AboutUsPage/images/logo9.png";

const Backed = () => {
    const glass = {
        background: "rgba(255,255,255,0.7)",
        borderRadius: 16,
        border: "1px solid rgba(255,255,255,0.75)",
        boxShadow: "0 8px 24px rgba(15, 35, 90, 0.08)",
        backdropFilter: "saturate(160%) blur(10px)",
        WebkitBackdropFilter: "saturate(160%) blur(10px)",
    };

    const textColStyle = { paddingRight: 24, maxWidth: 620 };
    const smallMuted = { color: "#2b4a6a" };
    const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9];

    // ⬇ NEW: observe the whole section (animate when it enters)
    const sectionRef = useRef(null);
    const [reveal, setReveal] = useState(false);

    useEffect(() => {
        const node = sectionRef.current;
        if (!node) return;

        const io = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setReveal(true);
                    io.unobserve(node); // run once; remove this line if you want repeat
                }
            },
            { threshold: 0.3 } // 30% visible then fire
        );

        io.observe(node);
        return () => io.disconnect();
    }, []);

    // inline transition styles – only depend on `reveal`
    const leftAnimStyle = {
        opacity: reveal ? 1 : 0,
        transform: reveal ? "translateX(0)" : "translateX(-24px)",
        transition: "transform 700ms ease-out, opacity 700ms ease-out",
        willChange: "transform, opacity",
    };
    const rightAnimStyle = {
        opacity: reveal ? 1 : 0,
        transform: reveal ? "translateX(0)" : "translateX(24px)",
        transition: "transform 700ms ease-out, opacity 700ms ease-out",
        willChange: "transform, opacity",
    };

    return (
        <section
            ref={sectionRef}
            className="position-relative"
            style={{
                overflow: "hidden",
                padding: "72px 0 100px",
                marginTop: 80,
            }}
        >
            {/* decorative arcs (as-is) */}
            <div
                aria-hidden
                style={{
                    position: "absolute",
                    top: -240,
                    left: -180,
                    width: 1200,
                    height: 600,
                    borderBottomLeftRadius: 1200,
                    borderBottomRightRadius: 1200,
                    pointerEvents: "none",
                }}
            />
            <div
                aria-hidden
                style={{
                    position: "absolute",
                    bottom: -260,
                    right: -220,
                    width: 1400,
                    height: 620,
                    borderTopLeftRadius: 1400,
                    borderTopRightRadius: 1400,
                    background:
                        "radial-gradient(1200px 600px at 50% 100%, rgba(173, 199, 227, 0.25), rgba(173,199,227,0) 70%)",
                    pointerEvents: "none",
                }}
            />

            <div
                className="px-3 px-md-4 mx-auto position-relative"
                style={{ maxWidth: "73%", zIndex: 1 }}
            >
                <div
                    className="row g-4 g-lg-5 align-items-start"
                    style={{ display: "grid", gridTemplateColumns: "1.05fr 1fr", gap: 28 }}
                >
                    {/* LEFT — animate from left on reveal */}
                    <div style={{ ...textColStyle, ...leftAnimStyle }}>
                        <h2
                            style={{
                                fontSize: 44,
                                fontFamily: "'Inter', sans-serif",
                                fontWeight: 650,
                                color: "#1C1C1C",
                                lineHeight: 1.2,
                            }}
                        >
                            Backed by
                        </h2>

                        <p
                            style={{
                                fontSize: "20px",
                                color: "#6B6B6B",
                                fontWeight: 400,
                                fontFamily: "'Inter', sans-serif",
                                lineHeight: 1.2,
                            }}
                        >
                            We are proudly supported by leading institutions, dynamic accelerators and visionary
                            innovation platforms that deeply believe in our journey and wholeheartedly support our
                            mission.
                        </p>

                        <p
                            style={{
                                ...smallMuted,
                                fontFamily: "'Inter', sans-serif",
                                fontSize: "20px",
                                color: "#6B6B6B",
                                lineHeight: 1.2,
                                maxWidth: 630,
                            }}
                        >
                            Their invaluable backing provides us with the essential resources, expert mentorship,
                            and strategic opportunities needed to drive impactful innovation and achieve our
                            ambitious goals. We're committed to leveraging this support to foster groundbreaking
                            ideas and deliver transformative solutions.
                        </p>

                        <p
                            style={{
                                fontStyle: "italic",
                                color: "#0B4A8F",
                                fontWeight: 600,
                                fontSize: 18,
                                marginTop: 10,
                            }}
                        >
                            Driving innovation forward, together.
                        </p>
                    </div>

                    {/* RIGHT — animate from right on reveal */}
                    <div style={rightAnimStyle}>
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                                gap: 22,
                            }}
                        >
                            {logos.map((src, i) => (
                                <div
                                    key={i}
                                    style={{
                                        ...glass,
                                        padding: "26px 18px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        minHeight: 120,
                                    }}
                                >
                                    <img
                                        src={src}
                                        alt={`Partner ${i + 1}`}
                                        loading="lazy"
                                        decoding="async"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: 90,
                                            objectFit: "contain",
                                            filter: "saturate(105%)",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* existing responsive tweaks */}
                <style>{`
          @media (prefers-reduced-motion: reduce) {
            /* disable transitions for accessibility */
            [style*="transform: translateX("] {
              transform: none !important;
              opacity: 1 !important;
              transition: none !important;
            }
          }
          @media (max-width: 1200px) {
            .row { grid-template-columns: 1fr; }
          }
          @media (max-width: 576px) {
            .row { grid-template-columns: 1fr; }
            .row > div:last-child > div {
              grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
              gap: 16px !important;
            }
          }
        `}</style>
            </div>
        </section>
    );
};

export default Backed;
